
interface SearchResult {
   Address_Id: string
   Full_Address: string
   Name: string
}

import Vue from 'vue'
import { Typeahead } from 'uiv'
import * as Api from '@/api/AddressFinder'

export default Vue.extend({
   name: 'AddressFinder',
   props: {
      id: String,
      label: String,
      countryCode: { type: String, default: 'nz' },
      placeholder: { type: String, default: '' },
      disabled: { type: Boolean, default: false },
      showLabel: { type: Boolean, default: true },
   },
   data() {
      return {
         searchText: '',
         searchResult: '',
         searching: false,
      }
   },
   methods: {
      onSearchTextChanged() {
         if (this.searchText) {
            this.$emit('textChanged', this.searchText)
         }
      },
      async addressSearch(query: string, done: (items: any[]) => void) {
         try {
            if (query.length <= 3) {
               done([])
               return
            }
            this.searching = true
            const result = await Api.findAddress(query, this.countryCode.toLowerCase())
            this.searching = false
            done(result)
         } catch (err) {
            done([])
            this.searching = false
            this.$emit('error', err.message)
         }
      },
      async addressSelected(address: SearchResult) {
         if (address && address.Address_Id) {
            try {
               const details = await Api.addressDetails(
                  address.Address_Id,
                  this.countryCode.toLowerCase()
               )
               this.$emit('input', details)
            } catch (err) {
               this.$emit('error', err.message)
            }
         }
      },
   },
   components: {
      Typeahead,
   },
})
